import { colors } from './colors';
import { defaults } from './defaults';
import { devices } from './devices';
import { spacing } from './spaces';
import * as tokens from '@laredoute/design-system/tokens';

const theme = {
    name: 'theme-v2',
    colors,
    defaults,
    spacing,
    devices
};

export { theme, tokens };
